<template>
  <div>
    <div class="bto-sb-widget">
      <div class="bto-sb-widget-title bto-sb-title-icon bto-sb-title-big">
        <span class="bto-app-icon bto-app-history"></span>
        <h3>{{ t("Mobile.BetslipFound") }}</h3>
      </div>
    </div>
    <div class="bto-sb-widget-wrap bto-sb-history-wrap">
      <div class="bto-sb-widget bto-sb-history">
        <div class="bto-sb-history-items">
          <MyBetsInlineHeader :type="'checker'" :bet="betDetails" />
          <MyBetsInlineDetails :type="'checker'" :betDetails="betDetails" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../../../store/index';
  import base from './base';
  import MyBetsInlineHeader from '../mybet-header/my-bets-inline-header';
  import MyBetsInlineDetails from '../mybet-details/my-bets-inline-details';

  export default {
    name: 'BetslipCheckerInline',
    extends: base,
    components: {
      MyBetsInlineHeader,
      MyBetsInlineDetails,
    },
    created() {
      store.commit('hideAfterRouteWidgets');
    },
  };
</script>
